/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import {
  BuilderFormSchemaFactory,
  BuilderUserContext,
  FormRootSchema,
  FormState,
  FormStateSchema,
} from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';
import { whenEditMode } from '@gh/common-shared';
import { FormMode } from '@gh/core-ui';

import { SystemVarsJobDetails } from '../../resources/model/system-vars-jobs.model';
import { SystemVarsJobsCommonSettingsSubTabFormState } from './sys-vars-jobs-common-settings-subtab/sys-vars-jobs-common-settings-subtab.form.service';

@Injectable()
export class SystemVarsJobsTabFormState extends FormState<SystemVarsJobDetails> {

  constructor(schemaFactory: BuilderFormSchemaFactory,
              private commonSettingsForm: SystemVarsJobsCommonSettingsSubTabFormState,
              private userContext: BuilderUserContext) {
    super(schemaFactory);
  }

  build(details: SystemVarsJobDetails): void {
    const mode = this.userContext.hasPermission(BuilderPermission.Setup.SystemVariables.Jobs.EDIT) ?
      FormMode.EditMode : FormMode.ViewMode;
    this.setMode(mode);

    this.commonSettingsForm.build(details.commonSettings, mode);

    this.initSchema(details);

    this.setChildForm('commonSettings', this.commonSettingsForm);
  }

  protected buildSchema(_: SystemVarsJobDetails, { root, native }: FormStateSchema): FormRootSchema {
    return root({
      enabled: whenEditMode(),
      mode: this.mode,
      optimisticLock: true,
      children: {
        id: void 0,
        commonSettings: native(this.commonSettingsForm.group),
      },
    });
  }
}
